import { Card, Empty } from "antd";
import test_img from "../../images/32637972_7843794.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import Router from "..";
import { CATEGORY_MAPPING, CATEGORY_STYLES } from "../utils/categories";
import { useUserStore } from "../../stores/userStore";
import {
  useNewCampaigns,
  usePopularCampaigns,
  useTrendingHashtags,
  useDailyTopCreators,
} from "../hooks/useDashboard";
import { getDeadlineListSummary } from "../utils/campaignDeadline";

export const Dashboard = () => {
  const [keyword, setKeyword] = useState("");
  const history = useHistory();
  const { userInfo } = useUserStore();

  const { data: newCampaigns = [] } = useNewCampaigns();
  const { data: popularCampaigns = [] } = usePopularCampaigns();
  const { data: trendingHashtags = [] } = useTrendingHashtags();
  const { data: dailyTopCreators = [] } = useDailyTopCreators();

  const handleKeywordChange = (e) => {
    setKeyword(e.target.value);
  };

  const handleSearch = () => {
    if (keyword.trim()) {
      history.push(`/influencer/search?keyword=${encodeURIComponent(keyword)}`);
    }
  };

  const handleCampaignClick = (campaign) => {
    const campaignId = campaign.id;
    history.push(`/campaign/search?campaign_id=${campaignId}`, {
      campaign,
    });
  };

  const handleInfluencerClick = (influencer) => {
    history.push(`/influencer/search?influencer_id=${influencer.unique_id}`);
  };

  return (
    <>
      <h2 className="md:text-4xl text-3xl font-bold">대시보드</h2>
      <div className="max-w-[1920px] mx-auto">
        {userInfo?.user_info?.user_type === "brand" && (
          <div className="mb-8">
            <div className="flex-1 flex md:max-w-[800px] mb-20">
              <input
                type="text"
                placeholder="크리에이터 검색하기"
                value={keyword}
                onChange={handleKeywordChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
                className="w-full h-[37px] border border-gray-300 border-r-0 rounded-l-lg px-[7px] py-[11px] outline-none text-lg md:text-xl"
              />
              <button
                onClick={handleSearch}
                className="w-[60px] md:w-[80px] h-[37px] px-3 md:px-4 py-2 bg-[#171717] hover:bg-[#333333] text-white rounded-r-lg text-lg md:text-xl flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </div>
          </div>
        )}

        <div className="p-8 rounded-[12px] bg-white shadow-md mb-24">
          <h1 className="md:text-3xl text-2xl font-semibold px-2 mb-6">
            인기 해시태그
          </h1>
          {trendingHashtags?.length > 0 ? (
            <div className="px-2 py-6 flex flex-wrap gap-2">
              {trendingHashtags.map((tag, idx) => (
                <button
                  key={idx}
                  className={
                    "flex items-center gap-2 rounded-full px-3 py-1 transition-transform duration-200 hover:scale-105 bg-[#F9A03F] text-white"
                  }
                >
                  <span className="text-xl md:text-2xl"># {tag}</span>
                </button>
              ))}
            </div>
          ) : (
            <div className="py-12">
              <Empty description="인기 해시태그가 없습니다" />
            </div>
          )}
        </div>

        {userInfo?.user_info?.user_type !== "brand" && (
          <>
            <div className="p-8 rounded-[12px] bg-white shadow-md mb-24">
              <h1 className="md:text-3xl text-2xl font-semibold px-2 mb-6">
                인기 캠페인
              </h1>
              {popularCampaigns?.length > 0 ? (
                <Router.DashboardCarousel
                  items={popularCampaigns}
                  renderItem={(campaign, idx) => (
                    <div className="px-2 py-6 h-full">
                      <Card
                        key={campaign.id}
                        onClick={() => {
                          handleCampaignClick(campaign);
                        }}
                        className="h-full rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:scale-[1.01] transition-all duration-200"
                        cover={
                          <div className="relative aspect-[16/9] overflow-hidden min-h-[100px]">
                            <img
                              alt={campaign.title}
                              src={campaign.thumbnail || test_img}
                              className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                            <span className="absolute left-3 top-3 rounded-full bg-black/70 px-4 py-2 text-lg md:text-xl font-semibold text-white">
                              TOP {idx + 1}
                            </span>
                            <span
                              className="absolute bottom-3 left-3 rounded-md bg-white/90 px-2 py-1 text-base md:text-lg font-medium text-[#4E4E4E] shadow-md"
                              style={
                                CATEGORY_STYLES[campaign.campaign_category] ||
                                CATEGORY_STYLES.etc
                              }
                            >
                              {CATEGORY_MAPPING[campaign.campaign_category] ||
                                "기타"}
                            </span>
                          </div>
                        }
                        styles={{ body: { padding: "16px" } }}
                      >
                        <h3 className="line-clamp-1 text-xl md:text-2xl font-semibold text-black mb-11 flex-1">
                          {campaign.title}
                        </h3>
                        <div className="flex items-center justify-between gap-2 text-lg md:text-xl text-[#4E4E4E] mt-auto">
                          <span className="flex-shrink-0 whitespace-nowrap font-medium">
                            일일 지원{" "}
                            <span className="text-[#52C41A] font-semibold">
                              {campaign.todayApplyCount}
                            </span>
                          </span>
                        </div>
                      </Card>
                    </div>
                  )}
                />
              ) : (
                <div className="py-12">
                  <Empty description="인기 캠페인이 없습니다" />
                </div>
              )}
            </div>

            <div className="p-8 rounded-[12px] bg-white shadow-md mb-24">
              <h1 className="md:text-3xl text-2xl font-semibold px-2 mb-6">
                신규 캠페인
              </h1>
              {newCampaigns?.length > 0 ? (
                <Router.DashboardCarousel
                  items={newCampaigns}
                  renderItem={(campaign) => {
                    const endDateText = getDeadlineListSummary(campaign.end_at);

                    return (
                      <div className="px-2 py-6 h-full">
                        <Card
                          onClick={() => {
                            handleCampaignClick(campaign);
                          }}
                          className="h-full rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:scale-[1.01] transition-all duration-200"
                          cover={
                            <div className="relative aspect-[16/9] overflow-hidden min-h-[100px]">
                              <img
                                alt={campaign.title}
                                src={campaign.thumbnail || test_img}
                                className="w-full h-full object-cover"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                              <span
                                className="absolute left-3 top-3 rounded-md bg-white/90 px-2 py-1 text-base md:text-lg font-medium text-[#4E4E4E] shadow-md"
                                style={
                                  CATEGORY_STYLES[campaign.campaign_category] ||
                                  CATEGORY_STYLES.etc
                                }
                              >
                                {CATEGORY_MAPPING[campaign.campaign_category] ||
                                  "기타"}
                              </span>
                            </div>
                          }
                          styles={{ body: { padding: "16px" } }}
                        >
                          <h3 className="line-clamp-1 text-xl md:text-2xl font-semibold text-black mb-11 flex-1">
                            {campaign.title}
                          </h3>

                          <div className="space-y-2 truncate text-ellipsis">
                            <div className="flex items-center justify-between gap-2 text-base md:text-lg font-medium text-[#4E4E4E]">
                              <span className="flex-shrink-0 whitespace-nowrap">
                                모집{" "}
                                <span className="text-[#52C41A] font-semibold">
                                  {campaign.recruit_count}명
                                </span>
                              </span>

                              {endDateText && (
                                <div className="flex items-center gap-1 text-sm md:text-base">
                                  <span
                                    className={
                                      endDateText.includes("D-") ||
                                      endDateText.includes("오늘")
                                        ? "text-red-500 font-semibold"
                                        : "text-[#4E4E4E]"
                                    }
                                  >
                                    {endDateText}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </Card>
                      </div>
                    );
                  }}
                />
              ) : (
                <div className="py-12">
                  <Empty description="신규 캠페인이 없습니다" />
                </div>
              )}
            </div>
          </>
        )}

        {userInfo?.user_info?.user_type === "brand" && (
          <div className="p-8 rounded-[12px] bg-white shadow-md mb-24">
            <h1 className="md:text-3xl text-2xl font-semibold px-2 mb-6">
              일일 인기 크리에이터
            </h1>
            {dailyTopCreators?.length > 0 ? (
              <Router.DashboardCarousel
                items={dailyTopCreators}
                renderItem={(creator) => (
                  <div className="px-2 py-6 h-full">
                    <Card
                      className="h-full rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:scale-[1.01] transition-all duration-200"
                      styles={{ body: { padding: 16 } }}
                      cover={
                        <div className="relative aspect-[16/9] overflow-hidden min-h-[100px]">
                          <img
                            src={creator.profile_url}
                            alt={creator.nickname}
                            className="w-full h-full object-cover"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />

                          <span className="absolute left-3 top-3 rounded-full bg-black/70 px-4 py-2 text-lg md:text-xl font-semibold text-white">
                            TOP {creator.rank}
                          </span>
                        </div>
                      }
                      onClick={() => handleInfluencerClick(creator)}
                    >
                      <h3 className="line-clamp-1 text-xl md:text-2xl font-semibold text-black">
                        {creator.nickname}
                      </h3>

                      <p className="text-base md:text-lg text-[#8C8C8C] mb-4">
                        @{creator.unique_id}
                      </p>

                      <div className="flex items-center justify-start">
                        <span className="text-lg md:text-xl font-semibold">
                          {Number(creator.follower_count).toLocaleString()}
                        </span>
                      </div>
                    </Card>
                  </div>
                )}
              />
            ) : (
              <div className="py-12">
                <Empty description="일일 인기 크리에이터가 없습니다" />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};
